
// ENTRANCE ANIMATION SVG




// HEADER APPEARANCE SECTION
function openMobileMenu() {
    document.getElementById('mobileMenuOverlay').classList.add('active');
    document.getElementById('mobileMenuPanel').classList.add('active');
  }

  function closeMobileMenu() {
    document.getElementById('mobileMenuOverlay').classList.remove('active');
    document.getElementById('mobileMenuPanel').classList.remove('active');
  }

  document.addEventListener("scroll", function () {
    if (window.scrollY > 10) {
      document.body.classList.add("scrolled");
    } else {
      document.body.classList.remove("scrolled");
    }
  });

document.addEventListener('DOMContentLoaded', function () {
  const header = document.querySelector('.malu-header');
  if (!header) return;

  function updateHeaderOnScroll() {
    // Only apply effect on desktop
    if (window.innerWidth <= 768) {
      header.classList.remove('scrolled');
      return;
    }

    if (window.scrollY > 10) {
      header.classList.add('scrolled');
    } else {
      header.classList.remove('scrolled');
    }
  }

  // Run once on load
  updateHeaderOnScroll();

  // Listen for scroll + resize
  window.addEventListener('scroll', updateHeaderOnScroll);
  window.addEventListener('resize', updateHeaderOnScroll);
});